import type { User } from '../types/user';
import { hasKeycloakClientRole, type KeycloakClientRole } from './clientRoles';

function hasClientRole(user: User | null, role: KeycloakClientRole): boolean {
  return hasKeycloakClientRole(user?.roles, role);
}

export function hasAnyClientRole(
  user: User | null,
  roles: readonly KeycloakClientRole[],
): boolean {
  return roles.some((role) => hasClientRole(user, role));
}

export function isLacAdmin(user: User | null): boolean {
  return hasClientRole(user, 'LAC_ADMIN');
}

export function canAccessTenantManagement(user: User | null): boolean {
  return hasAnyClientRole(user, ['ADMIN', 'LAC_ADMIN']);
}
